import { Theme } from '../types/theme'

/**
 * Normalize a raw cookie value to a valid Theme, or null if invalid.
 */
export function parseThemePreference(raw: string | null | undefined): Theme | null {
  if (raw === Theme.DARK || raw === Theme.LIGHT) {
    return raw
  }
  return null
}
